import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Package } from '../package'
import { PackageService } from '../package.service'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { PackageDetailComponent } from '../package-detail/package-detail.component'
import { AsyncPipe } from '@angular/common'

export interface IPackageDialogOptions {
  readonly pkgId?: string
  readonly pkg?: Package
  readonly company: string
}

@Component({
  selector: 'app-package-detail-dialog',
  templateUrl: './package-detail-dialog.component.html',
  styleUrls: ['./package-detail-dialog.component.scss'],
  imports: [PackageDetailComponent, AsyncPipe],
})
export class PackageDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  pkg$ = new BehaviorSubject<Package>(null)
  readonly company: string
  private packageService = inject(PackageService)
  private toastService = inject(ElderToastService)
  private dialogRef = inject<MatDialogRef<PackageDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IPackageDialogOptions>(MAT_DIALOG_DATA)
    if (data.pkg) {
      this.pkg = data.pkg
    } else if (data.pkgId) {
      this.loadPackage(data.pkgId)
    } else {
      throw new Error('Either package object or packageId must be defined!')
    }
    if (!data.company) {
      throw new Error('Company must be defined!')
    }
    this.company = data.company
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public set pkg(pkg: Package) {
    this.pkg$.next(pkg)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private loadPackage(id: string): void {
    this.packageService.findById(id).subscribe({
      next: (pkg) => (this.pkg = pkg),
      error: (err) => this.toastService.error('Failed to load package!', err),
    })
  }
}
